import { createActionsHook } from 'src/lib/sweetState';

import { ProjectFolderStore } from './ProjectFolderStore';

export const useProjectFolderActions = createActionsHook(ProjectFolderStore);
